import { css, CSSResult, unsafeCSS } from 'lit';
import { designTokenFactory } from '../../utils/design-tokens.js';

const dt = designTokenFactory('radiobutton');
const dt$ = (tokenPath: string, state?: string): CSSResult => unsafeCSS(`var(${dt(tokenPath, state)})`);

const hostStyles = css`
  ::slotted(input[type='radio']) {
    position: absolute;
    inset: ${dt$('radio.inset')};
  }
`;

const buttonLabelStyles = css`
  .button-label {
    width: 100%;
    border: none;
    padding: 0;
    border-radius: var(${dt('border.radius')});
    outline-width: var(${dt('border.width')}, 0);
    outline-style: var(${dt('border.style')}, solid);
    outline-color: var(${dt('border.color')}, transparent);
    outline-offset: var(${dt('border.offset')}, 0);
    box-shadow: var(${dt('shadow')}, none);
    background: var(${dt('background')}, transparent);
    display: flex;
    flex-direction: column;
    position: relative;
    transition:
      outline-offset ${dt$('transition.duration')} ease,
      outline-width ${dt$('transition.duration')} ease,
      outline-color ${dt$('transition.duration')} ease,
      box-shadow ${dt$('transition.duration')} ease,
      background-color ${dt$('transition.duration')} ease;
    cursor: pointer;
  }

  :host([checked]) .button-label {
    outline-color: var(${dt('border.color', 'selected')}, var(${dt('border.color')}, transparent));
    box-shadow: var(${dt('shadow', 'selected')}, var(${dt('shadow')}, none));
    background-color: var(${dt('background.color', 'selected')}, var(${dt('background.color')}, transparent));
  }
`;

const imageStyles = css`
  ::slotted(img) {
    width: 100%;
    aspect-ratio: calc(sqrt(2)) / 1;
    border-top-left-radius: var(${dt('border.radius')});
    border-top-right-radius: var(${dt('border.radius')});
    object-fit: cover;
  }
`;

const resetButtonStyles = css`
  .y-reset-button {
    background: var(${dt('resetbutton.background')});
    color: var(${dt('resetbutton.background')});
    border-width: var(${dt('resetbutton.border.width')});
    border-style: var(${dt('resetbutton.border.style')});
    border-color: var(${dt('resetbutton.border.color')});
    border-radius: var(${dt('resetbutton.border.radius')});
    box-shadow: var(${dt('resetbutton.shadow')});
    width: var(${dt('resetbutton.size')});
    height: var(${dt('resetbutton.size')});
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    inset: var(${dt('resetbutton.offset')}, 1rem);
    left: var(${dt('resetbutton.offset')}, 1rem);
    opacity: 0;
    transform: translateY(-10px) scale(0.8);
    pointer-events: none;
    transition:
      background-color 0.2s ease,
      color 0.2s ease,
      box-shadow 0.2s ease;
  }

  :host([checked]) .y-reset-button {
    opacity: 1;
    transform: translateY(0) scale(1);
    pointer-events: auto;
  }

  ::slotted(svg) {
    pointer-events: none;
  }
`;

const footerStyles = css`
  .button-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: ${dt$('footer.padding')};
  }
`;

export default [hostStyles, buttonLabelStyles, imageStyles, resetButtonStyles, footerStyles];
